export const APPOINTMENT_STATUS_LABELS = {
  pending: 'Pendente',
  in_progress: 'Em Andamento',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  customer_absent: 'Cliente Ausente',
} as const;

export const DAY_OF_WEEK_LABELS = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado',
} as const;

export const TIME_INTERVALS = [15, 30, 45, 60] as const;

export const USER_ROLES = {
  admin: 'Administrador',
  store_admin: 'Administrador de Loja',
} as const;

/** Earliest date available for client booking (inclusive, YYYY-MM-DD) */
export const BOOKING_START_DATE = '2026-02-27';

/** Default number of items per page for paginated queries */
export const DEFAULT_PAGE_LIMIT = 10;
